import React from 'react'

function Form(props) {
  const { children, ...rest } = props

  return (
    <div>
      <form {...rest}>{children}</form>
    </div>
  )
}

export default Form
